"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMap = void 0;
class GoogleMap {
    constructor(map, lat = 51.5867778, lng = 4.3173359, zoom = 10) {
        this.markers = [];
        const center = { lat, lng };
        this.map = new google.maps.Map(map, {
            center,
            zoom,
            styles: GoogleMap.getMapStyling()
        });
    }
    addLocations(locations) {
        this.clearLocations();
        Object.entries(locations).forEach(([, location]) => {
            const popUp = this.getPopUp(location);
            const infowindow = new google.maps.InfoWindow({
                content: popUp,
            });
            let iconPath = '/app/themes/lyfter-child/img/assets/';
            if (location.dealer_type) {
                iconPath += 'map-marker-' + location.dealer_type + '.png';
            }
            else {
                iconPath += 'map-marker-90.png';
            }
            const marker = new google.maps.Marker({
                position: { lat: location.lat, lng: location.lng },
                map: this.map,
                title: location.title,
                icon: iconPath,
            });
            marker.addListener("click", () => {
                infowindow.open({
                    anchor: marker,
                    map: this.map,
                    shouldFocus: false,
                });
            });
            this.markers.push(marker);
        });
    }
    getPopUp(location) {
        return '<div class="location-pop-up">' +
            '<h5 class="title">' + location.title + '</h5>' +
            '<small>' + location.name + '</small>' +
            '<small>' + location.post_code + ', ' + location.city + '</small>' +
            '<small>' + location.country + '</small>' +
            '</div>';
    }
    clearLocations() {
        this.markers.forEach((marker) => marker.setMap(null));
        this.markers = [];
    }
    center(lat, lng) {
        var _a;
        if (this.markers.length === 0) {
            return;
        }
        const bounds = new google.maps.LatLngBounds({ lat, lng });
        this.markers.forEach((marker) => {
            const { lat, lng } = marker.getPosition() || {};
            if (lat && lat() && lng && lng()) {
                bounds.extend({ lat: lat(), lng: lng() });
            }
        });
        (_a = this.map) === null || _a === void 0 ? void 0 : _a.fitBounds(bounds);
    }
    static getNavigateToUrl(location, args = {
        travelmode: 'driving',
    }) {
        return `https://www.google.com/maps/dir/?${new URLSearchParams({
            api: '1',
            dir_action: 'navigate',
            destination: location.street_name + ' ' + location.city,
            destination_place_id: location.place_id,
            ...args,
        })}`;
    }
    static getMapStyling() {
        return [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ];
    }
}
exports.GoogleMap = GoogleMap;
